var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('div',{staticClass:"brand-block"},[_c('img',{staticClass:"page-logo",attrs:{"src":_vm.logoUrl,"alt":"欧小橙"}}),_c('h2',{staticClass:"page-title"},[_vm._v("欧小橙代拍一站式web管理平台")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }